'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoComply = void 0;
var transport_1 = require("../../transport");
var GeoComply = /** @class */ (function () {
    function GeoComply() {
    }
    GeoComply.prototype.getLicense = function (params) {
        return transport_1.transport.request('geoComply/getLicense', params);
    };
    GeoComply.prototype.authorize = function (params) {
        return transport_1.transport.request('geoComply/authorize', params);
    };
    return GeoComply;
}());
exports.GeoComply = GeoComply;
